module.exports = __webpack_public_path__ + "static/img/superhero_03.5ef54b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile@1x/pic/superhero_03.png
// module id = Ofpv
// module chunks = 0